export function stringifyQuery(url: string, parameters: Record<string, string | number>) {
    const queryString = Object.entries(parameters)
        .map(([key, value]) => [key, String(value ?? '').trim()])
        .filter(([, value]) => Boolean(value))
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

    return queryString ? `${url}?${queryString}` : url;
}
